import { motion } from "framer-motion";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { Link } from "react-router-dom";
import { SEO } from "../components/SEO";

export default function MentionsLegalesPage() {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="min-h-screen bg-[#F5F5F0]"
    >
      <Navbar />
      <SEO
        path="/mentions-legales"
        title="Mentions Légales — PROBWA La Réunion"
        description="Mentions légales de PROBWA — Eco Bois Concept, distributeur REBO Bamboo à La Réunion. Informations juridiques, hébergeur et responsabilité."
      />
      <main className="pt-24">
        {/* Hero */}
        <section className="py-12 md:py-16 bg-[#2D2D2D]">
          <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
            <motion.h1
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="text-4xl md:text-5xl font-bold text-[#E8E8E8]"
              style={{ fontFamily: "'DM Serif Display', serif" }}
              data-testid="mentions-legales-title"
            >
              Mentions <span className="text-[#8BC34A]">Légales</span>
            </motion.h1>
          </div>
        </section>

        {/* Content */}
        <section className="py-16 md:py-24">
          <div className="max-w-4xl mx-auto px-6 md:px-12">
            <div className="bg-white rounded-3xl p-8 md:p-12 shadow-xl space-y-8">
              
              <p className="text-[#3A3A3A] leading-relaxed">
                Conformément aux dispositions de la loi n° 2004-575 du 21 juin 2004 pour la confiance 
                en l'économie numérique, il est précisé aux utilisateurs du site ProBwa l'identité 
                des différents intervenants dans le cadre de sa réalisation et de son suivi.
              </p>

              <div>
                <h2 className="text-2xl font-bold text-[#2D2D2D] mb-4" style={{ fontFamily: "'DM Serif Display', serif" }}>
                  ÉDITION DU SITE
                </h2>
                <p className="text-[#3A3A3A] leading-relaxed">
                  Le présent site, accessible à l'URL www.probwa.re (le « Site »), est édité par :<br /><br />
                  <strong>PROBWA</strong>, société au capital de 900 euros, inscrite au R.C.S. de 
                  SAINT-DENIS-DE-LA-REUNION sous le numéro <strong>982 037 558 R.C.S. Saint Denis de La Réunion</strong>, 
                  dont le siège social est situé au :<br /><br />
                  <strong>7 RUE ELIE EUDOR BUREAU N3<br />
                  97460 SAINT-PAUL<br />
                  La Réunion</strong><br /><br />
                  Représenté(e) par <strong>Isaac RODRIGUEZ LOPEZ</strong> dûment habilité(e).
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-[#2D2D2D] mb-4" style={{ fontFamily: "'DM Serif Display', serif" }}>
                  HÉBERGEMENT
                </h2>
                <p className="text-[#3A3A3A] leading-relaxed">
                  Le Site est hébergé par la société :<br /><br />
                  <strong>OVH SAS</strong><br />
                  2 rue Kellermann – BP 80157<br />
                  59053 Roubaix Cedex 1<br />
                  France<br />
                  Contact téléphonique : 1007
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-[#2D2D2D] mb-4" style={{ fontFamily: "'DM Serif Display', serif" }}>
                  DIRECTEUR DE PUBLICATION
                </h2>
                <p className="text-[#3A3A3A] leading-relaxed">
                  Le Directeur de la publication du Site est <strong>Isaac RODRIGUEZ LOPEZ</strong>.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-[#2D2D2D] mb-4" style={{ fontFamily: "'DM Serif Display', serif" }}>
                  NOUS CONTACTER
                </h2>
                <p className="text-[#3A3A3A] leading-relaxed">
                  <strong>Par téléphone :</strong> +262 692 50 26 85<br /><br />
                  <strong>Par email :</strong> probwalareunion@gmail.com<br /><br />
                  <strong>Par courrier :</strong><br />
                  BUREAU N3, 7 RUE ELIE EUDOR<br />
                  97460 SAINT-PAUL<br />
                  La Réunion
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-[#2D2D2D] mb-4" style={{ fontFamily: "'DM Serif Display', serif" }}>
                  DONNÉES PERSONNELLES
                </h2>
                <p className="text-[#3A3A3A] leading-relaxed">
                  Le traitement de vos données à caractère personnel est régi par notre{" "}
                  <Link to="/politique-confidentialite" className="text-[#8BC34A] hover:underline">
                    Charte du respect de la vie privée
                  </Link>, disponible depuis la section « Politique de Confidentialité », 
                  conformément au Règlement Général sur la Protection des Données 2016/679 
                  du 27 avril 2016 («RGPD»).
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-[#2D2D2D] mb-4" style={{ fontFamily: "'DM Serif Display', serif" }}>
                  PROPRIÉTÉ INTELLECTUELLE
                </h2>
                <p className="text-[#3A3A3A] leading-relaxed">
                  L'ensemble des éléments constituant ce site (textes, graphismes, logiciels, 
                  photographies, images, sons, vidéos, plans, noms, logos, marques, créations 
                  et œuvres protégeables diverses, bases de données, etc.) ainsi que le site 
                  lui-même sont la propriété exclusive de PROBWA ou de ses partenaires.<br /><br />
                  Toute représentation ou reproduction, intégrale ou partielle, du site ou de 
                  l'un quelconque des éléments qui le composent, par quelque procédé que ce soit, 
                  sans l'autorisation expresse préalable de PROBWA, est interdite et constituerait 
                  une contrefaçon sanctionnée par les articles L.335-2 et suivants du Code de la 
                  propriété intellectuelle.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-[#2D2D2D] mb-4" style={{ fontFamily: "'DM Serif Display', serif" }}>
                  LIMITATION DE RESPONSABILITÉ
                </h2>
                <p className="text-[#3A3A3A] leading-relaxed">
                  PROBWA s'efforce d'assurer au mieux l'exactitude et la mise à jour des informations 
                  diffusées sur ce site. Toutefois, PROBWA ne peut garantir l'exactitude, la précision 
                  ou l'exhaustivité des informations mises à disposition sur ce site.<br /><br />
                  En conséquence, PROBWA décline toute responsabilité :<br />
                  • Pour toute imprécision, inexactitude ou omission portant sur des informations 
                  disponibles sur le site<br />
                  • Pour tous dommages résultant d'une intrusion frauduleuse d'un tiers ayant entraîné 
                  une modification des informations mises à disposition sur le site<br />
                  • Et plus généralement pour tous dommages, directs ou indirects, quelles qu'en soient 
                  les causes, origines, natures ou conséquences
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-[#2D2D2D] mb-4" style={{ fontFamily: "'DM Serif Display', serif" }}>
                  LIENS HYPERTEXTES
                </h2>
                <p className="text-[#3A3A3A] leading-relaxed">
                  Le site peut contenir des liens hypertextes vers d'autres sites. PROBWA n'exerce 
                  aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu 
                  ou aux éventuels collectes et traitements de données personnelles effectués par ces sites.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-[#2D2D2D] mb-4" style={{ fontFamily: "'DM Serif Display', serif" }}>
                  DROIT APPLICABLE
                </h2>
                <p className="text-[#3A3A3A] leading-relaxed">
                  Les présentes mentions légales sont régies par le droit français. En cas de litige 
                  et à défaut de résolution amiable, les tribunaux français seront seuls compétents.
                </p>
              </div>

              <div className="pt-4 border-t border-gray-200">
                <p className="text-sm text-[#9E9E9E]">
                  Dernière mise à jour : Février 2026
                </p>
              </div>

            </div>
          </div>
        </section>
      </main>
      <Footer />
    </motion.div>
  );
}
